var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "线下打款",
        width: "720px",
        footer: null,
        zIndex: 2000
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("a-alert", {
            attrs: {
              message: "温馨提示：请确保打款公司和签约主体公司保持一致",
              type: "error"
            }
          }),
          _vm._v(" "),
          _c("ul", { staticClass: "plat" }, [
            _c(
              "li",
              [
                _c("span", [_vm._v("收款账户：")]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticClass: "select",
                    attrs: {
                      value: _vm.account.bankAccount,
                      dropdownStyle: { zIndex: 10000 }
                    },
                    on: { change: _vm.handleChangeAccount }
                  },
                  _vm._l(_vm.list, function(item, index) {
                    return _c(
                      "a-select-option",
                      { key: index, attrs: { value: item.bankAccount } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.accountName) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticClass: "select",
                    attrs: {
                      value: _vm.currency,
                      dropdownStyle: { zIndex: 10000 }
                    },
                    on: { change: _vm.handleChangeCurrency }
                  },
                  _vm._l(_vm.currencyList, function(item, index) {
                    return _c(
                      "a-select-option",
                      { key: index, attrs: { value: item.currency } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.currencyLabel) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "amount" }, [
              _c("span", [_vm._v("应付金额：")]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.payInfo.currencySymbol) +
                    _vm._s(_vm.payInfo.amount)
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "foreign" }, [
              _c("span", [_vm._v("币种/金额：")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.currencyList.find(function(c) {
                          return c.currency === _vm.currency
                        }) &&
                          _vm.currencyList.find(function(c) {
                            return c.currency === _vm.currency
                          }).currencySymbol
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("a-input-number", {
                    staticClass: "input",
                    attrs: { min: 0 },
                    model: {
                      value: _vm.currencyPayAmount,
                      callback: function($$v) {
                        _vm.currencyPayAmount = $$v
                      },
                      expression: "currencyPayAmount"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "account-info" }, [
            _c("div", [_vm._v("账户名称：" + _vm._s(_vm.account.accountName))]),
            _vm._v(" "),
            _c("div", [_vm._v("银行账号：" + _vm._s(_vm.account.bankAccount))]),
            _vm._v(" "),
            _c("div", [_vm._v("银行号：" + _vm._s(_vm.account.bankNo))]),
            _vm._v(" "),
            _c("div", [_vm._v("分行代码：" + _vm._s(_vm.account.branchCode))]),
            _vm._v(" "),
            _c("div", [_vm._v("SWIFT code：" + _vm._s(_vm.account.bankCode))]),
            _vm._v(" "),
            _c("div", [
              _vm._v("银行名称(Bank Name)：" + _vm._s(_vm.account.bankName))
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("银行地址：" + _vm._s(_vm.account.accountOpeningLocation))
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v("公司地址：" + _vm._s(_vm.account.companyContactAddress))
            ])
          ]),
          _vm._v(" "),
          _c(
            "a-upload-dragger",
            {
              attrs: {
                name: "file",
                action: _vm.uploadUrl,
                accept: "image/png,image/jpeg,image/jpg",
                "file-list": _vm.fileList,
                "before-upload": _vm.beforeUploadHandler
              },
              on: { change: _vm.handleChangeUpload }
            },
            [
              _c(
                "p",
                { staticClass: "ant-upload-drag-icon" },
                [_c("a-icon", { attrs: { type: "inbox" } })],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "ant-upload-text" }, [
                _vm._v("点击上传凭证")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "ant-upload-hint" }, [
                _vm._v(
                  "\n        请选择对应的支付账户进行线下打款，打款成功后请上传凭证截图，预计1-3个工作日审核完成。"
                ),
                _c("br"),
                _vm._v(
                  "\n        只能上传jpg/png格式文件，文件不能超过10MB\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.payLoading },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-384ec95d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384ec95d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/module/components/intlOfflinePay/index.vue
// module id = null
// module chunks = 